<template>
    <v-dialog max-width="600px" v-model="dialog">
        <!-- <v-btn flat slot="activator" color="primary">Add a parallel solution concept</v-btn> -->
        <v-btn slot="activator" class="mx-2" flat fab>
        <v-icon dark>add</v-icon>
        </v-btn>
        <v-card>
            <v-card-title> 
                <span class="headline font-weight-bold">Add a metric:</span> 
                <!-- <v-alert
                :value="true"
                color="primary"
                icon="info"
                class="caption text-lg-justify"
                outline>
                You have seleect
              </v-alert>  -->
            </v-card-title>

            <v-card-text>
                <v-form class="px-3" ref="form">

                    <v-text-field 
                        outline 
                        :label="metricLabelText" 
                        v-model="metrictitle" 
                        :rules="textInputRules">
                        </v-text-field>

                    <v-select
                        v-model="defaultmetriccategory"
                        :items="metriccategory"
                        :label="metriccategoryLabelText"
                        :rules="selectInputRules" 
                        outline
                        ></v-select>



                    <!-- <v-checkbox 
                    v-model="solutiondetaildoesthissolutionhavedisruptivequalities" 
                    label="This solution concept has disruptive qualities">
                    </v-checkbox> -->



                    <!-- <v-btn flat color="primary" @click="submit_message" :loading="loading">Add Metric</v-btn>  -->
                    <v-btn flat color="primary" @click="dummySubmit" :loading="loading">Add Metric</v-btn> 
                    <!-- <v-btn flat color="primary" @click="submit" :loading="loading">Add Metric</v-btn>  -->
                    <!-- <v-btn flat to="/bifdashboard" color="primary" class="mx-2 mt-3" :loading="loading">Add Quote</v-btn> -->
                    <v-btn flat @click="dialog = false">Cancel</v-btn>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import db from '../fb'
import gvars from '../globalvariables'

export default {
    name: '',
    data() {
        return{
            metrictitle: 'Number of Positive feedback per 100 early adopters',

            metricLabelText: 'Enter a name briefly describing the metric',
            metricHintText: 'If the problem has evolved significantly and one or more new solutions can be suggested, Please provide one metric which will help measure the usefulness of parallel product concepts built around the original solution idea.',
            
            metriccategoryLabelText: 'Enter the Metric Category',
            defaultmetriccategory: 'Problem space',
            metriccategory: ['Problem space', 'Solution space', 'Evangelism', 'Scale', 'Evolution', 'Ecosystem'],
       
            textInputRules: [
                    v => !!v || 'This field is required',
                    v => v.length >= 3 || 'Minimum length is 3 characters'
                ],
            loading: false,
            dialog: false
        }
    },
    methods: {
        submit() {

             if(this.$refs.form.validate()) {
            //console.log(this.nameofthesolution, this.briefdescriptionofthesolution)
            this.loading = true;
             

            //details = {}

            const metric = {
                metrictitle: this.metrictitle,
                metriccategory: this.defaultmetriccategory
            }

            //details['prefs'] = firstprefdetails;
 

            //
            //xuWrU7qOYXxLjL97QoCe

        var dbref = db.collection('projects').doc(this.getProjectID()).collection('metrics');

        dbref.add(metric).then(() =>{
            //console.log('Parallel solution concept added')
                      this.loading = false;
          this.dialog = false;
          this.$emit('metricconfirmed')
        });


    //     db.collection('projects').doc('Yx3r6dHUeFFdGvY6Acvy').collection('quotesregardingfirstprefsolutionconcept').update(quote).then(() => {
    //       //console.log("added to db!", docRef.id)
    //       this.loading = false;
    //       this.dialog = false;
    //       this.$emit('quoteconfirmed')
    //    });

             }
        },
        submit_message() {

            this.$dialog.confirm({
        title: 'Confirm',
        desc: 'this is a confirm!',
        confirm: () => {
          window.alert('yes')
        },
        cancel: () => {
          window.alert('no')
        }
      })
            

        },
        dummySubmit(){
            this.loading = false;
          this.dialog = false;

        },
    getProjectID(){
      return gvars.PROJECTID;
    } 
    }
}
</script>
